<template>
  <div>
    <div class="message-card-item" v-for="(card, index) in cardList" :key="index" @click="onClick(card)">
      <template v-if="card.url">
        <div class="card-top">
          <div class="title ellipsis-2">{{card.url.name}}</div>
          <div class="title-sub ellipsis-1">{{card.url.classification}}</div>
        </div>
        <div class="card-bottom">
          <div class="date-row" v-if="card.time">{{formateDate(card)[0]}}</div>
          <div class="time-row">
            <van-icon class="icon" name="underway-o" />
            <span class="time-text" v-if="card.url.time">{{card.url.time}}</span>
            <!-- <span class="time-text" v-if="card.url.time">{{formateDate(card.url.time)[1]}}</span> -->
          </div>
          <div class="address-row">
            <van-icon class="icon" name="location-o" />
            <span class="address-text">{{card.url.location}}</span>
          </div>
        </div>
      </template>
    </div>

    <div v-if="problemData.length">
      <CardProblem :data="problemData" @card-problem="onCardProblem" />
    </div>
  </div>
</template>

<script>
  import CardProblem from './CardProblem'

  export default {
    name: "ActivityCard",
    components: {
      CardProblem
    },
    props: {
      miniEnv: {
        type: Boolean,
        default: false
      },
      cardList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      problemData() {
        return this.cardList[this.cardList.length - 1].rec_problem_list || []
      }
    },
    methods: {
      onClick(card) {
        const url = card.url.meeting_url
        if (!url) {
          return
        }

        if (this.miniEnv) {
          window.location.href = url
        }
      },
      formateDate(time) {
        // 2025年3月25日14:30-16:30
        return time.replace('\n', '').replace('日', '日 ').split(' ')
      },
      onCardProblem(problem) {
        this.$emit('card-problem', problem)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .message-card-item {
    padding: 12px 10px;
    box-sizing: border-box;
    margin-bottom: 8px;
    background: #FFFFFF;
    border-radius: 4px;
    &:last-child{
      margin-bottom: 0;
    }
    .card-top {
      padding-bottom: 10px;
      position: relative;
      &::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        opacity: 0.85;
        border-bottom: 1px dashed #C7C7C7;
      }
    }
    .title {
      font-weight: 500;
      font-size: 15px;
      color: rgba(0,0,0,0.85);
      margin-bottom: 8px;
    }
    .title-sub {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    .card-bottom {
      padding-top: 10px;
      .date-row {
        font-weight: 500;
        font-size: 14px;
        color: rgba(0,0,0,0.85);
      }
      .time-row{
        margin-top: 4px;
        .icon {
          color: rgba(0,0,0,0.65);
          font-size: 12px;
          margin-right: 2px;
          vertical-align: middle;
        }
        .time-text {
          font-weight: 400;
          font-size: 15px;
          color: rgba(0,0,0,0.65);
        }
      }
      .address-row{
        margin-top: 4px;
        .icon {
          color: rgba(0,0,0,0.65);
          font-size: 12px;
          margin-right: 2px;
          vertical-align: middle;
        }
        .address-text {
          font-weight: 400;
          font-size: 14px;
          color: rgba(0,0,0,0.65);
        }
      }
    }
  }
</style>